import { ShoppingCartAction } from '../actions/ShoppingCartAction';

const initState = {
    shoppingCart : {},
    isSimTypePatchDone : false,
    isUnpaidBillsPatchDone : false,
    isSecurityDepositPatchDone : false,
    isProcessContextPut : false
}

const ShoppingCartReducer = (state:any = initState, action:any) => {
    const { type } = action;
    const { payload } = action;

    switch (type) {
        case ShoppingCartAction.SHOPPING_CART_CREATE_SUCCESS:
        case ShoppingCartAction.SHOPPING_CART_PATCH_SIGNATURE_SUCCESS:
        case ShoppingCartAction.SHOPPING_CART_UPDATE_SUCCESS:
            return {...state, shoppingCart:payload}

        case ShoppingCartAction.SHOPPING_CART_PATCH_SIM_TYPE_SUCCESS:
            return {...state, shoppingCart:payload, isSimTypePatchDone:true}

        case ShoppingCartAction.SHOPPING_CART_PUT_PROCESS_CONTEXT_SUCCESS:
            return {...state, shoppingCart:payload, isProcessContextPut:true}

        case ShoppingCartAction.SHOPPING_CART_PATCH_UNPAID_BILLS_SUCCESS:
            return {...state, shoppingCart:payload}

        case ShoppingCartAction.SHOPPING_CART_PATCH_UNPAID_BILLS_VERIFIED:
            return {...state, isUnpaidBillsPatchDone:payload}

        case ShoppingCartAction.SHOPPING_CART_PATCH_SECURITY_DEPOSIT_SUCCESS:
            return {...state, shoppingCart:payload}

        case ShoppingCartAction.SHOPPING_CART_PATCH_SECURITY_DEPOSIT_VERIFIED:
                return {...state, isSecurityDepositPatchDone:payload}

        case ShoppingCartAction.SHOPPING_CART_VALIDATION_SUCCESS:
        case ShoppingCartAction.UPDATE_VALIDATE_CART_SUCCESS:
            return {...state, shoppingCart:payload.shoppingCart}

        case ShoppingCartAction.SHOPPING_CART_INVALIDATE:
            return {...state, shoppingCart:{}}
            
        default:
            return state;
    }
}

export default ShoppingCartReducer;